import { Box, Text } from '@chakra-ui/react';

export const StatBox = ({
  label,
  value,
  color = 'gray.800',
  subtext,
  compact,
}: {
  label: string;
  value: string | null;
  color?: string;
  subtext?: string;
  compact?: boolean;
}) => (
  <Box
    bg={compact ? 'white' : 'gray.50'}
    p={compact ? 3 : 4}
    borderRadius="md"
    textAlign="center"
  >
    <Text fontSize="xs" color="gray.500" fontWeight="semibold" mb={1}>
      {label}
    </Text>
    <Text fontSize={compact ? 'md' : 'lg'} fontWeight="bold" color={color}>
      {value ?? '—'}
    </Text>
    {subtext && (
      <Text fontSize="xs" color="gray.400" mt={0.5}>
        {subtext}
      </Text>
    )}
  </Box>
);
